import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ButtonShape } from 'components';

import { useStyles } from './style';

const LogIn: React.FC<{}> = () => {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();

  const login = () => {
    window.location.replace('/login');
  };

  return (
    <div className={classes.root}>
      <h2 className={classes.title}>{t('WelcomeHeader')}</h2>
      <p className={classes.description}>{t('WelcomeText')}</p>
      <div className={classes.buttonsWrapper}>
        <ButtonShape type="button" className={classes.button} onClick={login}>
          {t('SignIn')}
        </ButtonShape>
        <span className={classes.em}>{t('Or')}</span>
        <ButtonShape
          className={classes.button}
          onClick={() => history.push('/sign-up')}
        >
          {t('Join')}
        </ButtonShape>
      </div>
      <Link to="/password-reset" className={classes.passwordResetLink}>
        {t('PasswordForgot')}
      </Link>
    </div>
  );
};

export default LogIn;
